import moment from 'moment';

export const mapError = ({
    hasHelperText = true,
    meta: { touched, error, warning } = {},
    input,
    ...props
}) => {
    const errorProps =
        touched && (error || warning)
            ? { ...props, ...input, error: Boolean(error || warning) }
            : { ...input, ...props };

    if (touched && hasHelperText && (error || warning)) {
        errorProps.helperText = error || warning;
    }

    return errorProps;
};

export const isStateLess = (Component) => !Component.render;

const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const generateNumberId = (length = 7) => {
    const timestamp = +new Date();

    let ts = timestamp.toString();
    let parts = ts.split('').reverse();
    let id = '';

    for (let i = 0; i < length; ++i) {
        let index = getRandomInt(0, parts.length - 1);
        id += parts[index];
    }

    return id;
};

export const getTimeDifference = (date) => {
    const today = moment(Date.now());
    const comparableDay = moment(date);

    const day = today.diff(comparableDay, 'days');
    if (day == 0) return `${today.diff(comparableDay, 'minutes')} min ago`;
    else if (day > 29) return `${today.diff(comparableDay, 'months')} month ago`;

    return `${day} day ago`;
};

const getNestedValues = (key, value) => {
    let temp = value;
    const keyList = key.split('.');
    keyList.forEach((innerKey) => (temp = temp?.[innerKey]));
    return !!temp;
};

export const checkPropertyComplete = (listing) => {
    const requiredKeySet = [
        'headline',
        'exitStrategy.strategyList',
        'interior',
        'overview',
        'description',
    ];

    if (listing)
        return requiredKeySet.every((key) => {
            return getNestedValues(key, listing);
        });
    else return false;
};

export const checkPhotoComplete = (listing) => {
    const requiredKeySet = ['photos.coverPhoto', 'photos.propertyPhotos'];

    if (listing)
        return requiredKeySet.every((key) => {
            return getNestedValues(key, listing);
        });
    else return false;
};

export const checkLocationComplete = (listing) => {
    const requiredKeySet = ['location.coordinates', 'location.poiList'];

    if (listing)
        return requiredKeySet.every((key) => {
            return getNestedValues(key, listing);
        });
    else return false;
};

export const checkComparisonComplete = (listing) => {
    const comparison = listing?.comparison;

    return (
        comparison?.comparisonDescription &&
        ((comparison?.recentRentalsHidden === 'false' && comparison?.recentRentals) ||
            comparison?.recentRentalsHidden === 'true') &&
        ((comparison?.recentSalesHidden === 'false' && comparison?.recentSales) ||
            comparison?.recentSalesHidden === 'true')
    );
};

export const checkRefurbComplete = (listing) => {
    const requiredKeySet = ['refurb'];

    if (listing)
        return requiredKeySet.every((key) => {
            return getNestedValues(key, listing);
        });
    else return false;
};

export const checkFigureComplete = (listing) => {
    const { figures, exitStrategy } = listing || {};
    const strategyList = exitStrategy?.strategyList || [];
    console.warn(strategyList);

    return figures && strategyList.every((strategy) => strategy.ROI !== undefined);
};

export const checkListingFormComplete = (listing) => {
    return (
        checkPropertyComplete(listing) &&
        checkPhotoComplete(listing) &&
        checkLocationComplete(listing) &&
        checkComparisonComplete(listing) &&
        checkRefurbComplete(listing) &&
        checkFigureComplete(listing)
    );
};
